var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusWarningOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7,8.5a.76.76,0,0,1-.75-.75V5.25a.75.75,0,0,1,1.5,0v2.5A.76.76,0,0,1,7,8.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 10.5,
    r: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.29,14H1.71A1.71,1.71,0,0,1,.18,11.52L5.47,1A1.71,1.71,0,0,1,8.53,1l5.29,10.57A1.71,1.71,0,0,1,12.29,14ZM7,1.5a.21.21,0,0,0-.19.12L1.52,12.19a.21.21,0,0,0,.19.31H12.29a.21.21,0,0,0,.19-.31L7.19,1.62A.21.21,0,0,0,7,1.5Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusWarningOutline);
export default __webpack_public_path__ + "static/media/status-warning-outline.26368037279ae5ef1347f5d693109bb1.svg";
export { ForwardRef as ReactComponent };